<template>
    <card :class="{
            'p-2': dense
          }"
          :no-padding="noPadding || dense"
          :flat="!raised"
          :color="color"
    >
        <div class="text-lg font-medium">
            <slot name="title"></slot>
        </div>
        <div class="text-xs">
            <slot name="subtitle"></slot>
        </div>
        <slot></slot>
    </card>
</template>

<script>
    export default {
        name: "List",
        props: {
            noPadding: {type: Boolean, default: false},
            dense: {type: Boolean, default: false},
            raised: {type: Boolean, default: false},
            color: {type: [String, null], default: null}
        },
        components: {
            card: () => import('@/components/Card.vue')
        }
    }
</script>

<style scoped>

</style>